module.exports = __webpack_public_path__ + "img/b4.2cc37128.png";